import React, { Component } from "react";
import Lightbox from "react-image-lightbox";

class GaleriaLuxury extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false
    };
  }
  render() {
    const images = [
      "assets/img/luxury/luxury-suite-hermosillo-2.png",
      "assets/img/luxury/luxury-suite-hermosillo-5.png",
      "assets/img/luxury/luxury-suite-hermosillo-8.png",
      "assets/img/luxury/luxury-suite-hermosillo-11.png",
      "assets/img/luxury/luxury-suite-hermosillo-14.png",
      "assets/img/luxury/luxury-suite-hermosillo-17.png",
      "assets/img/luxury/luxury-suite-hermosillo-20.png",
      "assets/img/luxury/luxury-suite-hermosillo-23.png"
    ];
    let imageItems = images.map((image, i) => {
      return (
        <div className="col-lg-4 col-md-4 col-sm-6">
          <div className="gd-item">
            <img src={image} alt="" />
            <a
              onClick={() => this.setState({ isOpen: true, photoIndex: i })}
              title=""
              className="html5lightbox zoom-img-3"
            >
              <img src="/assets/images/zoom.png" alt="" />
            </a>
          </div>
        </div>
      );
    });
    const { photoIndex, isOpen } = this.state;

    return (
      <div
        className="tab-pane fade show active"
        id="tab1"
        role="tabpanel"
        aria-labelledby="tab_1"
      >
        <div className="gallery-grid">
          <div className="row">{imageItems}</div>
        </div>
        {isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </div>
    );
  }
}
export default GaleriaLuxury;
